<div class="grid-wrapper mxs-drawer">
    <mat-toolbar [hidden]="hideButtons" class="mxs-drawer_toolbar">
        <!--Default Grid buttons-->
        <ng-container *ngFor="let button of gridButtons">
            <mx-button [buttonModel]="button"></mx-button>
        </ng-container>

        <!--Custom Grid buttons-->
        <ng-container
                *ngTemplateOutlet="buttonsTemplate; context:{selection: selection}">
        </ng-container>

        <span class="toolbar-fill-remaining-space"></span>
        <div class="grid-help" *mxInfo="gridId"></div>
        <mat-form-field class="mxs-input mx-show-columns" *ngIf="showColumns">
            <mat-label>{{'Show columns:' | translate}}</mat-label>
            <mat-select #mySel
                        [formControl]="columnService.columnsSelectControl"
                        (closed)="searchOption.value=null"
                        (opened)="mySel.panel.nativeElement.scrollTop = 0; searchOption.focus()"
                        multiple>
                <div class="upper-row">
                    <mx-button *ngIf="isDeselectedOption()" [buttonModel]="selectAllButton"></mx-button>
                    <mx-button *ngIf="!isDeselectedOption()" [buttonModel]="deselectAllButton"></mx-button>
                    <mat-form-field placeholder="Search" class="mxs-input mat-input-field" >
                        <input matInput #searchOption/>
                    </mat-form-field>
                </div>
                <mat-option [style.display]="filterOptionsIfContainSearchParam(opt.name, searchOption.value) ? 'flex' : 'none' " *ngFor="let opt of columnsSelectOptions  trackBy: columnId"  [value]="opt.id">{{opt.name | translate}}</mat-option>
            </mat-select>
        </mat-form-field>
    </mat-toolbar>

    <div class="grid-table-wrapper mxs-drawer_container">
        <table mat-table [dataSource]="dataSource" matSort [matSortActive]="(sortActive) ? sortActive : ''"
               [matSortDirection]="(sortDirection) ? (sortDirection) : ''"
               [matSortDisableClear] = "sortActive || (sort && sort.active)"
               (matSortChange)="saveSort($event)"
                >
            <ng-container *ngIf="selectionMode === 'multi'"
                          matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="true"  class="grid-checkbox-column">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  (change)="$event ? masterToggle() : null"
                                  [checked]="selection.hasValue() && isAllSelected()"
                                  [indeterminate]="selection.hasValue() && !isAllSelected()"
                                  [disabled]="isAllDisabled() || !allowSelectAll">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let element">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  (change)="$event ? selection.toggle(element) : null"
                                  [checked]="selection.isSelected(element)"
                                  [disabled]="isRowDisabled(element)">
                    </mat-checkbox>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                </td>
            </ng-container>

            <ng-container *ngFor="let column of columnsAll; trackBy: columnProp">
                <ng-container [matColumnDef]="column.prop">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="allowReorder || column.isThumbnail || !column.sortable">
                        <ng-container *ngTemplateOutlet="defaultHeaderTemplate; context:{column:column}"></ng-container>
                    </th>
                    <td mat-cell
                        *matCellDef="let element; let rowIndex = index;"
                        [ngClass]="column.type == 'date' ? 'nowrap' : ''">
                        <div class="mat-cell--wrapper">

                            <div class="mat-cell--content">
                                <ng-container *ngIf="useReferencedCellTemplate(column); else notReferencedCellTemplate">
                                    <ng-container *ngTemplateOutlet="referencedCellTemplate; context:{column: column, element: element, rowIndex: rowIndex}"></ng-container>
                                </ng-container>

                                <ng-template #notReferencedCellTemplate>
                                    <ng-container *ngTemplateOutlet="column.cellTemplate ? column.cellTemplate : cellTemplate; context:{column: column, element: element, rowIndex: rowIndex, readonly: hideButtons}"></ng-container>
                                </ng-template>
                                <div *ngIf="getErrorByIndex(rowIndex, column.prop)" class="column-error">
                                    {{getErrorByIndex(rowIndex, column.prop)}}
                                </div>
                            </div>
                        </div>
                    </td>
                    <td mat-footer-cell *matFooterCellDef>
                        <ng-container *ngTemplateOutlet="defaultFooterTemplate; context:{column:column}"></ng-container>
                    </td>
                </ng-container>
            </ng-container>

            <ng-container matColumnDef="reorder" *ngIf="allowReorder">
                <th mat-header-cell *matHeaderCellDef class="grid-reorder-column"></th>
                <td mat-cell *matCellDef="let element; let rowIndex = index;">
                    <div [matTooltip]="(disableUpButton(rowIndex) ? CANT_MOVE_IN_READONLY_MODE : MOVE_UP) | translate" class="btn-grid-sort-wrapper">
                        <button type="button" class="btn-grid-sort" [disabled]="disableUpButton(rowIndex)"
                                (click)="onOrderUp(rowIndex); $event.stopPropagation()">
                            <i class="material-icons">arrow_upward</i>
                        </button>
                    </div>
                    <div [matTooltip]="(disableDownButton(rowIndex) ? CANT_MOVE_IN_READONLY_MODE : MOVE_DOWN) | translate" class="btn-grid-sort-wrapper">
                        <button type="button" class="btn-grid-sort" [disabled]="disableDownButton(rowIndex)"
                                (click)="onOrderDown(rowIndex); $event.stopPropagation()">
                            <i class="material-icons">arrow_downward</i>
                        </button>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="visibleAndControlColumns; sticky: true" class="header-row" [ngClass]="{'hidden': isHeaderHidden}"></tr>
            <tr mat-row *matRowDef="let element; columns: visibleAndControlColumns; let rowIndex = index"
                [matTooltip]="getDisabledMessage(element) | translate"
                [hidden]="isRowInvisible(element)"
                matTooltipPosition="left"
                [matTooltipDisabled]="!getDisabledMessage(element)"
                (click)="getDisabledMessage(element) ? $event.preventDefault() : onRowClick($event, element)"
                (dblclick)="getDisabledMessage(element) ? $event.preventDefault() : onRowDblClick($event, element)"
                [ngClass]="{'grid-row-disabled': getDisabledMessage(element),
                'row-highlighted': (selection.isSelected(element)),
                'row-error': isRowWithError(rowIndex),
                'row-bold': isRowBold(element)
                }"
            ></tr>
            <tr mat-footer-row *matFooterRowDef="visibleAndControlColumns; sticky: true" class="grand-total-row" [ngClass]="{'hidden' : !isGrandTotalsDefined}"></tr>

            <!-- Group header cells-->
            <ng-container matColumnDef="groupHeader">
                <td [attr.colspan]="visibleAndControlColumns.length - 2" mat-cell *matCellDef="let group">
                    <strong class="group-header">
                        {{group.groupName + (group.invisibleRows.length > 0 ? ' (Number of invisible: ' + group.invisibleRows.length + ')' : '') | translate}}
                        <span *mxInfo="group.infoKey"></span>
                    </strong>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupReducer">
                <td colspan="1" mat-cell *matCellDef="let group">
                    <div fxFill fxLayoutAlign="center center" class="group-header">
                        <mat-icon *ngIf="!group.reduced">expand_less</mat-icon>
                        <mat-icon *ngIf="group.reduced">expand_more</mat-icon>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="groupOrder" >
                <td mat-cell colspan="1" *matCellDef="let group; let rowIndex = index;" >
                    <div fxFill fxLayoutAlign="right right">
                        <div *ngIf="allowGroupReorder" [matTooltip]="(disableGroupUpButton(rowIndex) ? CANT_MOVE_IN_READONLY_MODE : MOVE_UP) | translate" class="btn-grid-sort-wrapper">
                            <button type="button" class="btn-grid-sort" [disabled]="disableGroupUpButton(rowIndex)"
                                    (click)="$event.stopPropagation();onOrderGroupUp(rowIndex);">
                                <i class="material-icons group-order">arrow_upward</i>
                            </button>
                        </div>
                        <div *ngIf="allowGroupReorder" [matTooltip]="(disableGroupDownButton(rowIndex) ? CANT_MOVE_IN_READONLY_MODE : MOVE_DOWN) | translate" class="btn-grid-sort-wrapper">
                            <button type="button" class="btn-grid-sort" [disabled]="disableGroupDownButton(rowIndex)"
                                    (click)="$event.stopPropagation(); onOrderGroupDown(rowIndex);">
                                <i class="material-icons group-order">arrow_downward</i>
                            </button>
                        </div>
                    </div>
                </td>
            </ng-container>
            <!-- Group line -->
            <tr mat-row  class="clickable"
                *matRowDef="let row; columns: ['groupReducer','groupHeader', 'groupOrder']; when: isGroup"
                (click)="reduceGroup(row)" >
            </tr>
        </table>

        <div *ngIf="dataSource.data.length === 0" class="mxs-grid-no-data_container">
            <div class="mxs-grid-no-data_image mxs-grid-no-data_image--{{emptyGridParams().image}}">
                <div class="mxs-grid-no-data_image-text">{{getLabel(emptyGridParams().text) | translate}}</div>
            </div>

        </div>
    </div>

    <mx-pagination
                [dataSource]="dataSource"
                [updatePaginator]="this.collectionService._rows.length"
                [noPagination]="this.propsService.props.noPagination"
                [pageIndex]="this.propsService.props.pageIndex"
                [pageSize]="this.propsService.props.paginationLimit"
                (pageChange)="pageSelected($event)">

    </mx-pagination>

</div>


<!--TEMPLATES-->
<ng-template #referencedCellTemplate
             let-column="column"
             let-element="element"
             let-rowIndex="rowIndex">
    <a *ngIf="column.referencedReport && column.referencedReport.reportId"
       [routerLink]="[getPath(column.referencedReport.reportName), column.referencedReport.reportId]"
       [replaceUrl]="true"
       [queryParams]="getQueryParams(column.prop, rowIndex)">
            <ng-container *ngTemplateOutlet="cellTemplate; context:{column: column, element: element, rowIndex: rowIndex}"></ng-container>
    </a>

    <a *ngIf="column.referencedReport && !column.referencedReport.reportId"
       (click)="showReferenceReportFailure(column.referencedReport.reportName)">
            <ng-container *ngTemplateOutlet="cellTemplate; context:{column: column, element: element, rowIndex: rowIndex}"></ng-container>
    </a>

    <a *ngIf="column.referencedEntity && hasAccess(column.referencedEntity.entityName)"
       [routerLink]="[getReferencedEntityUrl(column, element)]"
       [queryParams]="getReferencedEntityQuery(column)">
            <ng-container *ngTemplateOutlet="cellTemplate; context:{column: column, element: element, rowIndex: rowIndex}"></ng-container>
    </a>
</ng-template>

<ng-template #cellTemplate
             let-column="column"
             let-element="element"
             let-rowIndex="rowIndex">

    <!--TODO: isThumbnail should be column.type 'thumbnail'-->
    <mx-thumbnail
            *ngIf="column.isThumbnail || column.prop === getThumbnailColumnName()"
            [defaultThumbnailClass]="getThumbnailClass(element)"
                  [thumbnailUrl]="getThumbnailUrl(element)">
    </mx-thumbnail>

    <ng-container *ngIf="!column.isThumbnail && column.prop !== getThumbnailColumnName()">
        <ng-container *ngIf="!!column.idProp && !!element[column.idProp] && element['linkProp']; else typedTemplate">
            <a [routerLink]="element['linkProp']" [replaceUrl]="true">
                <ng-container *ngTemplateOutlet="typedTemplate"></ng-container>
            </a>
        </ng-container>
    </ng-container>

    <ng-template #typedTemplate>
        <ng-container  [ngSwitch]="column.type">
            <ng-container *ngSwitchCase="'boolean'">
                <!-- If column is boolean and value is true, show check icon, else - nothing -->
                <i *ngIf="element[column.prop] === true" class="material-icons grid-table-icon">done</i>
            </ng-container>

            <ng-container *ngSwitchCase="'date'">
                {{(element[column.prop] | zoneDate: getGridColumnDateFormat(column.name))}}
            </ng-container>

            <ng-container *ngSwitchCase="'percent'">
                {{element[column.prop] | percent}}
            </ng-container>

            <ng-container *ngSwitchCase="'number'">
                {{element[column.prop] !== '0' ? (element[column.prop] | number: getNumberFormat(column)) : ''}}
            </ng-container>
            <ng-container *ngSwitchCase="'numberStr'">
                {{element[column.prop] !== '0' ? element[column.prop] : ''}}
            </ng-container>

            <ng-container *ngSwitchCase="'link'">
                <div [matTooltip]="element[column.prop]" matTooltipShowDelay="1000">
                    <a  target="_blank" [href]="element[column.prop]">{{element[column.prop]}}</a>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'html'">
                <span [innerHtml]="element[column.prop]"></span>
            </ng-container>
            <ng-container *ngSwitchCase="'text'">
                <div [matTooltip]="element[column.prop]" matTooltipShowDelay="1000">
                    {{element[column.prop]}}
                </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
                {{element[column.prop]}}
            </ng-container>
        </ng-container>
    </ng-template>
</ng-template>

<ng-template #defaultHeaderTemplate
             let-column="column">
    {{(column.label | mxTranslate)()}}
</ng-template>

<ng-template #defaultFooterTemplate
             let-column="column">

    <ng-container *ngIf="column.type === 'number'; else notNumberFooter">
        <b>{{getColumnGrandTotal(column.prop) !== '0' ? (getColumnGrandTotal(column.prop) | number: getNumberFormat(column)) : ''}}</b>
    </ng-container>
    <ng-template #notNumberFooter><b>{{getColumnGrandTotal(column.prop)}}</b></ng-template>

</ng-template>

<!--router outlet for dialog bo-object-form-dialog-->
<router-outlet *ngIf="propsService.props.showItemDetailsInDialog"></router-outlet>
